/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receivePaytypes from './receive-paytypes';

export default () => (dispatch) => {
    dispatch({
        type: actions.PAYTYPES_REQUEST,
    });

    return cecSdk
        .paytype()
        .getPaytypes()
        .then((paytypes) => {
            dispatch({
                type: actions.PAYTYPES_REQUEST_SUCCESS,
            });
            
            dispatch(receivePaytypes(paytypes));

            return paytypes;
        })
        .catch((e) => {
            dispatch({ type: actions.PAYTYPES_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
